import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddTouchesTypeComponent } from '../addtouchestype/addtouchestype.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { DatePipe } from '@angular/common';
import { AddToucheStatusTypeComponent } from '../addtouchestatustype/addtouchestatustype.component';


@Component({
  selector: 'app-addtouches',
  templateUrl: './addtouches.component.html',
  styleUrls: ['./addtouches.component.scss'] 
})

export class AddTouchesComponent implements OnInit {

  @Input() modulename: string;  
  @Input() entityID:number;
  transactionID:number=0;
  
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;

  myTouchesForm: FormGroup;
  TouchesType :any[]=[];
  TouchesTypeForFilter :any[]=[];
  AllContactTouchesList  :any[]=[];
  folderList: any[] = []; 
  folderId:number=0;
  getTagListResponseHolder: any;
  formDialog: FormGroup;
  OpenAddTouch:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;
  showDateTime:boolean=false;
  transactionIdFromPortal:number=0;
  @ViewChild('datetimecheckbox') datetimecheckbox: MatCheckbox; // Add this line
  statusList:any=[]=[];


  constructor(private dialog: MatDialog,private dialog1: MatDialog,private datePipe: DatePipe, public dialogRef: MatDialogRef<AddTouchesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService ) {  
     
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
    
  }  
  
  ngOnInit(): void {  
    //let groupaddtouchtype = {};
    //this.formDialog = new FormGroup(groupaddtouchtype);
    //this.formDialog.addControl('touchTypeName', this.formBuilder.control(''));   

    let group = {};
    this.myTouchesForm = new FormGroup(group);
    this.createFormTouches();
    this.getTouchTypeList();
    if(this.data && this.data.touch && this.data.touch.touchID>0){
      this.showStatusButton=true;
      this.touchTypeName=this.data.touch.touchTypeName;
    }else{
      this.showStatusButton=false;
    }
  }
       // Function to get time from a date string
  getTimeFromDate(dateString: string): string {
    if (dateString) {
      const date = new Date(dateString);
      return this.datePipe.transform(date, 'HH:mm'); // Format time as 'HH:mm'
    }
    return '';
  }

  // get touch type ==//
 getTouchTypeList() {
  if(this.data.moduleName=="Portal"){
    this.organizationId= this.data.organizationID;
    this.myOfficeID= this.data.officeID;  
    this.transactionIdFromPortal = this.data.transactionId;  
  }
  var ReqModel={
   userID: this.currentUser.UID,
   databaseId:Number(this.databaseId),
   organizationID:Number(this.organizationId),
   officeID:this.myOfficeID,
  }
   this.settingsService.getAllTouchTypeList(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.getTagListResponseHolder = response;
      if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
        this.TouchesType = this.getTagListResponseHolder.data;
        if(this.data && this.data.touch && this.data.touch.touchID>0){
          this.getStatusList(this.data.touch.touchTypeID);
           // Set values to form controls
            this.myTouchesForm.patchValue({
              touchtype: this.data.touch.touchTypeID,
              touchstatus: this.data.touch.touchStatus,
              touchDate: this.data.touch.touchDate,
              touchTime: this.getTimeFromDate(this.data.touch.touchTime),
              startDate: this.data.touch.startDate,
              startTime: this.getTimeFromDate(this.data.touch.startTime), // Set formatted time
              touchnotes: this.data.touch.touchNote,
              viewOn: this.data.touch.viewOn === 1 ? true : false
            });

            // Check if startDate has a value and set showDateTime accordingly
             if (this.data.touch.startDate) {
                 this.showDateTime = true;
                 this.datetimecheckbox.checked = true; // Check the checkbox
              }
           }        
      }
      else {
      }
    }
  });
  }

   // get touch Status ==//
  getStatusList(touchTypeID) {  
    var userId;
    if(this.data.moduleName=="Portal"){
      this.organizationId= this.data.organizationID;
      this.myOfficeID= this.data.officeID;  
      this.transactionIdFromPortal = this.data.transactionId;
      userId="2503b67f-bd65-4649-ab35-91348d4c4100";
      this.databaseId="1";
    }else{
      userId=this.currentUser.UID;
    }
  var ReqModel={
    touchTypeID:Number(touchTypeID),
    userId: userId,
    databaseId:Number(this.databaseId),
    organizationID:Number(this.organizationId),
    officeID:this.myOfficeID,
   }
   this.settingsService.getStatusesByTouchType(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.getTagListResponseHolder = response;
      if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
        this.statusList = this.getTagListResponseHolder.data;            
      }
      else {
      }
    }
  });
  }

  // Create touches
  createFormTouches(): void {
    this.myTouchesForm = this.formBuilder.group({
      touchtype: ['', [Validators.required]],      
      touchstatus: ['', [Validators.required]],  
      startDate: [''],
      startTime:[''],
      touchDate: [''],//EndDate
      touchTime:[''],//EndTime          
      touchnotes: ['', [Validators.required]],  
      viewOn:[false]  
    },);
  }
  
  close() {
    this.myTouchesForm.reset();
    this.dialog.closeAll();
  }

  showDateTimeSelect(event) {
    if(event.checked==true){
      this.showDateTime=true;
    }else{
      this.showDateTime=false;
    }   
  }

  async SaveTouchesDetail(data) {
    this.data;
    var modulename = this.data.moduleName;
    var folderId = this.data.folderID;
    var documentId = this.data.documentID;
    var placeholderID = this.data.placeholderID>0?this.data.placeholderID:0;
    var transactionID = this.data.transactionID>0?this.data.transactionID:0;

    if(this.data.moduleName=="Portal"){
      this.SavePortalTouchDetails(data,folderId,documentId,placeholderID);
      this.myTouchesForm.reset();
    }

    if(modulename == "Core"){
     this.SaveCoreTouchDetails(data,folderId,documentId,placeholderID,transactionID);
     this.myTouchesForm.reset();
    }  
    if(modulename == "Contact"){
      this.SaveContactTouchDetails(data,folderId,documentId,placeholderID,transactionID);
      this.myTouchesForm.reset();
    }  
     if(modulename == "Company"){
      this.SaveCompanyTouchDetails(data,folderId,documentId,placeholderID,transactionID);
      this.myTouchesForm.reset();
    } 
    if(modulename == "Forms"){
      this.SaveFormFolderTouchDetails(data);
      this.myTouchesForm.reset();
    } 
    if(modulename == "File Manager"){
      this.SaveFileManagerTouchDetails(data,folderId,documentId,placeholderID);
      this.myTouchesForm.reset();
    } 
  }


  async SaveCoreTouchDetails(data,folderId,documentId,placeholderID,transactionID) {
    var transactionID;
    var showOnPortal;
    if(data.viewOn==true){
      showOnPortal=1;
    }else{
      showOnPortal=0;
    }
     if(transactionID==0){
       transactionID=Number(sessionStorage.getItem('transactionID'));
     }
     if(transactionID>0){
      transactionID=Number(transactionID);
    }
    var ReqModel={
      touchID:0,
      touchTypeID:data.touchtype,
      touchStatus:data.touchstatus,

      touchDate:data.touchDate==""?null:data.touchDate,// EndDate
      touchTime:data.touchTime==""?null:data.touchTime,// EndTime

      startDate:data.startDate==""?null:data.startDate,
      startTime:data.startTime==""?null:data.startTime,

      touchNote:data.touchnotes,
      folderID:folderId,
      transactionID:transactionID,//Number(sessionStorage.getItem('transactionID')),
      documentID:documentId,
      placeholderID:placeholderID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      userID:this.currentUser.UID,
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList,
      viewOn:showOnPortal//data.viewOn
    }
    
    this.spinner=true;
    this.myTouchesForm.markAsPristine();
    if(this.data && this.data.touch && this.data.touch.touchID>0)
    {
      ReqModel.touchID=this.data.touch.touchID;
      const result = await this.coreService.UpdateCoreTouch(ReqModel).toPromise();
      if (result.status === this.statusConst.statusSuccess) {
        this.spinner=false; 
        this.dialogRef.close('Added');
        this.toastr.success("Activity created successfully.", '', {
          timeOut: 3000,
        });      
      }
      else { 
        this.spinner=false;
        this.dialogRef.close('Error');
      }
    }
  else
  {
    const result = await this.coreService.AddCoreTouch(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false; 
      this.dialogRef.close('Added');
      this.toastr.success("Activity created successfully.", '', {
        timeOut: 3000,
      });      
    }
    else { 
      this.spinner=false;
      this.dialogRef.close('Error');
    }
  } 
  }

  async SaveContactTouchDetails(data,folderId,documentId,placeholderID,transactionID) {
    var showOnPortal;
    var transactionID
    if(data.viewOn==true){
      showOnPortal=1;
    }else{
      showOnPortal=0;
    }
     if(transactionID==0){
       transactionID=Number(sessionStorage.getItem('transactionID'));
     }
     if(transactionID>0){
      transactionID=Number(transactionID);
    }
    var ReqModel={
      touchID:0,
      touchTypeID:data.touchtype,
      touchStatus:data.touchstatus,

      touchDate:data.touchDate==""?null:data.touchDate,// EndDate
      touchTime:data.touchTime==""?null:data.touchTime,// EndTime

      startDate:data.startDate==""?null:data.startDate,
      startTime:data.startTime==""?null:data.startTime,

      // touchDate:data.touchdate,
      // touchTime:data.touchtime==""?null:data.touchtime,
      touchNote:data.touchnotes,
      folderID:folderId,
      transactionID:transactionID,//Number(sessionStorage.getItem('transactionID')),
      documentID:documentId,
      placeholderID:placeholderID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      userID:this.currentUser.UID,
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList,
      viewOn:showOnPortal//data.viewOn
    }
    this.spinner=true;
    this.myTouchesForm.markAsPristine();
   
    if(this.data && this.data.touch && this.data.touch.touchID>0)
    {
      ReqModel.touchID=this.data.touch.touchID;
      const result = await this.coreService.UpdateContactTouch(ReqModel).toPromise();
      if (result.status === this.statusConst.statusSuccess) {
        this.spinner=false; 
        this.dialogRef.close('Added');
        this.toastr.success("Activity created successfully.", '', {
          timeOut: 3000,
        });      
      }
      else { 
        this.spinner=false;
        this.dialogRef.close('Error');
      }
    }
  else
  {
    const result = await this.coreService.AddContactTouch(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false; 
      this.dialogRef.close('Added');
      this.toastr.success("Activity created successfully.", '', {
        timeOut: 3000,
      });      
    }
    else { 
      this.spinner=false;
      this.dialogRef.close('Error');
    }
  }  
  }

  async SaveCompanyTouchDetails(data,folderId,documentId,placeholderID,transactionID) {
    var transactionID;
    var showOnPortal;
    if(data.viewOn==true){
      showOnPortal=1;
    }else{
      showOnPortal=0;
    }
     if(transactionID==0){
       transactionID=Number(sessionStorage.getItem('transactionID'));
     }
     if(transactionID>0){
      transactionID=Number(transactionID);
    }
    var ReqModel={
      touchID:0,
      touchTypeID:data.touchtype,
      touchStatus:data.touchstatus,

      touchDate:data.touchDate==""?null:data.touchDate,// EndDate
      touchTime:data.touchTime==""?null:data.touchTime,// EndTime

      startDate:data.startDate==""?null:data.startDate,
      startTime:data.startTime==""?null:data.startTime,

      // touchDate:data.touchdate,
      // touchTime:data.touchtime==""?null:data.touchtime,
      touchNote:data.touchnotes,
      folderID:folderId,
      transactionID:transactionID,//Number(sessionStorage.getItem('transactionID')),
      documentID:documentId,
      placeholderID:placeholderID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      userID:this.currentUser.UID,
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList,
      viewOn:showOnPortal//data.viewOn
    }
    this.spinner=true;
    this.myTouchesForm.markAsPristine();
    if(this.data && this.data.touch && this.data.touch.touchID>0)
    {
      ReqModel.touchID=this.data.touch.touchID;
      const result = await this.coreService.UpdateCompanyTouch(ReqModel).toPromise();
      if (result.status === this.statusConst.statusSuccess) {
        this.spinner=false; 
        this.dialogRef.close('Added');
        this.toastr.success("Activity created successfully.", '', {
          timeOut: 3000,
        });      
      }
      else { 
        this.spinner=false;
        this.dialogRef.close('Error');
      }
    }
  else
  {
    const result = await this.coreService.AddCompanyTouch(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false; 
      this.dialogRef.close('Added');
      this.toastr.success("Activity created successfully.", '', {
        timeOut: 3000,
      });      
    }
    else { 
      this.spinner=false;
      this.dialogRef.close('Error');
    }
  }
  }

  async SavePortalTouchDetails(data,folderId,documentId,placeholderID) {
    var ReqModel={
      touchID:0,
      touchTypeID:data.touchtype,
      touchStatus:data.touchstatus,

      touchDate:data.touchDate==""?null:data.touchDate,// EndDate
      touchTime:data.touchTime==""?null:data.touchTime,// EndTime

      startDate:data.startDate==""?null:data.startDate,
      startTime:data.startTime==""?null:data.startTime,

      touchNote:data.touchnotes,
     // folderID:folderId,
      transactionID:this.transactionIdFromPortal,
     // documentID:documentId,
     // placeholderID:placeholderID,
      organizationID:Number(this.data.organizationID),
      //databaseID:Number(this.databaseId),
      email:this.data.portalEmail,
      officeID:this.data.officeID,
      cType:this.data.cType,
      viewOn:1
    }
    this.spinner=true;
    this.myTouchesForm.markAsPristine();
    const result = await this.coreService.AddActivityForPortal(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false; 
      this.dialogRef.close('Added');
      this.toastr.success("Activity created successfully.", '', {
        timeOut: 3000,
      });      
    }
    else { 
      this.spinner=false;
      this.dialogRef.close('Error');
    } 
  }


  async SaveFormFolderTouchDetails(data) {
    var FormFolderId = this.data.formFolderID;
    var FormId = this.data.formID;
    var typeId= this.data.typeId;

    //1-For Folder , 2-For Form
   //var documentID =Object.values(this.data)[2]

    if(typeId ==1){
      FormFolderId= this.data.formFolderID;

      var ReqModelFolder={
        touchID:0,
        touchTypeID:data.touchtype,
        touchStatus:data.touchstatus,

        touchDate:data.touchDate==""?null:data.touchDate,// EndDate
        touchTime:data.touchtime==""?null:data.touchtime,// EndTime
  
        startDate:data.startDate==""?null:data.startDate,
        startTime:data.startTime==""?null:data.startTime,

        // touchDate:data.touchdate,
        // touchTime:data.touchtime==""?null:data.touchtime,
        touchNote:data.touchnotes,
        folderID: typeId, 
        transactionID:FormFolderId,
        documentID: null,
        organizationID:Number(this.organizationId),
        databaseID:Number(this.databaseId),
        userID:this.currentUser.UID,
        officeID:this.myOfficeID,
        OfficeIDList:this.OfficeIDList,
      }  
      const result = await this.coreService.AddFormTouch(ReqModelFolder).toPromise();
      if (result.status === this.statusConst.statusSuccess) {
        this.dialogRef.close('Added');
        this.toastr.success("Activity created successfully.", '', {
          timeOut: 3000,
        });   
      }
      else {      
        this.dialogRef.close('Error');
      } 
    }
    if(typeId ==2){
      FormFolderId= Object.values(this.data)[2];

      var ReqModelForm={
        touchID:0,
        touchTypeID:data.touchtype,
        touchStatus:data.touchstatus,
        touchDate:data.touchdate,
        touchTime:data.touchtime==""?null:data.touchtime,
        touchNote:data.touchnotes,
        folderID: typeId, 
        transactionID: Object.values(this.data)[1], //FormFolderId,
        documentID: Object.values(this.data)[2], //FormFolderId,
        organizationID:Number(this.organizationId),
        databaseID:Number(this.databaseId),
        userID:this.currentUser.UID,
        officeID:this.myOfficeID,
        OfficeIDList:this.OfficeIDList,
      }  
      const result = await this.coreService.AddFormTouch(ReqModelForm).toPromise();
      if (result.status === this.statusConst.statusSuccess) { 
        this.dialogRef.close('Added');
        this.toastr.success("Activity created successfully.", '', {
          timeOut: 3000,
        });
      }
      else {      
        this.dialogRef.close('Error');
      } 
    } 
  }


  async SaveFileManagerTouchDetails(data,folderId,documentId,placeholderID) {
    var showOnPortal;
    if(data.viewOn==true){
      showOnPortal=1;
    }else{
      showOnPortal=0;
    }
    var ReqModel={
      touchID:0,
      touchTypeID:data.touchtype,
      touchStatus:data.touchstatus,

      touchDate:data.touchDate==""?null:data.touchDate,// EndDate
      touchTime:data.touchTime==""?null:data.touchTime,// EndTime

      startDate:data.startDate==""?null:data.startDate,
      startTime:data.startTime==""?null:data.startTime,

      // touchDate:data.touchdate,
      // touchTime:data.touchtime==""?null:data.touchtime,
      touchNote:data.touchnotes,
      folderID:folderId,
      transactionID:0,
      documentID:documentId,
      placeholderID:0,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      userID:this.currentUser.UID,
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList,
      cType:5,// File Manager,
      faxMessageId:0,
      viewOn:showOnPortal//data.viewOn
    }
    this.spinner=true;
    this.myTouchesForm.markAsPristine();
    if(this.data && this.data.touch && this.data.touch.touchID>0)
    {
      ReqModel.touchID=this.data.touch.touchID;
      const result = await this.coreService.addFileManagerTouch(ReqModel).toPromise();
      if (result.status === this.statusConst.statusSuccess) {
        this.spinner=false; 
        this.dialogRef.close('Added');
        this.toastr.success("Activity created successfully.", '', {
          timeOut: 3000,
        });      
      }
      else { 
        this.spinner=false;
        this.dialogRef.close('Error');
      }
    }
  else
  {
    const result = await this.coreService.addFileManagerTouch(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false; 
      this.dialogRef.close('Added');
      this.toastr.success("Activity created successfully.", '', {
        timeOut: 3000,
      });      
    }
    else { 
      this.spinner=false;
      this.dialogRef.close('Error');
    }
  }
  }

  spinner:boolean=false;
  
  openDialogAddWithRef() {
    const dialogRef = this.dialog.open(AddTouchesTypeComponent, {     
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.getTouchTypeList();
      }  
    });     
  }

  openDialogAddStatusWithRef() {
    const dialogRef = this.dialog.open(AddToucheStatusTypeComponent, {
      data: {
        touchTypeID:this.myTouchesForm.get('touchtype').value,
        touchTypeName: this.touchTypeName 
      }     
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.getStatusList(this.myTouchesForm.get('touchtype').value);
        if(result>0){
          this.myTouchesForm.controls['touchstatus'].setValue(result);
        }        
      }  
    });     
  }

  closeAddTouchType(){
    this.formDialog.reset();    
    this.dialogRef.close();
  }

  fromDate:any;
  toDate:any;
  startTimes:any;
  endTimes:any;

  FromDate(event: any, ): void {
    this.fromDate=(event.target.value);
    if(this.fromDate!=undefined && this.toDate!=undefined){
      if(this.toDate<this.fromDate){
        this.fromDate=null;
        this.toastr.warning("Start date should not greater than end date.", '', {
          timeOut: 3000,
        }); 
        this.myTouchesForm.controls['startDate'].setValue('');        
        return;
      }
      if(this.fromDate>this.toDate){
        this.fromDate=null;
        this.toastr.warning("Start date should not greater than end date.", '', {
          timeOut: 3000,
        });       
        this.myTouchesForm.controls['startDate'].setValue('');   
        return;
      }
    }
   }
   
   ToDate(event: any, ): void {
    this.toDate=(event.target.value);
    if(this.fromDate!=undefined && this.toDate!=undefined){
      if(this.toDate<this.fromDate){
        this.toDate=null;
        this.toastr.warning("End date should not less than start date.", '', {
          timeOut: 3000,
        });
        this.myTouchesForm.controls['touchDate'].setValue('');
        return;
      }
      if(this.fromDate>this.toDate){
        this.fromDate=null;
        this.toastr.warning("Start date should not greater than end date.", '', {
          timeOut: 3000,
        }); 
        this.myTouchesForm.controls['startDate'].setValue(''); 
        return;
      }
    }
   }


   onStartTime(event: any){
    this.startTimes = new Date(new Date().toISOString().slice(0,10) + " " + event.target.value);
    if(this.startTimes!=undefined && this.endTimes!=undefined){
      if(this.endTimes<this.startTimes){
        this.myTouchesForm.controls['startTime'].setValue('');
        this.toastr.warning("Start Time should not greater than End Time.", '', {
          timeOut: 3000,
        });           
        this.startTimes=undefined;
        return;
      }

      // var hrs = moment.utc(moment(this.endTimes, "HH:mm:ss").diff(moment(this.startTimes, "HH:mm:ss"))).format("HH")
      // var min = moment.utc(moment(this.endTimes, "HH:mm:ss").diff(moment(this.startTimes, "HH:mm:ss"))).format("mm")
      // this.totalTimes = ([hrs,min].join(':'));
      // this.addInvoicePopUpForm.controls['totaltime'].setValue( this.totalTimes);
    }
  }

  onEndTime(event: any){
    this.endTimes = new Date(new Date().toISOString().slice(0,10) + " " + event.target.value);
    if(this.startTimes!=undefined && this.endTimes!=undefined){
      if(this.endTimes<this.startTimes){
       this.myTouchesForm.controls['touchTime'].setValue('');
       this.toastr.warning("End Time should not less than Start Time.", '', {
        timeOut: 3000,
       });             
       this.endTimes=undefined;
       return;
      }
     //  var hrs = moment.utc(moment(this.endTimes, "HH:mm:ss").diff(moment(this.startTimes, "HH:mm:ss"))).format("HH")
     //  var min = moment.utc(moment(this.endTimes, "HH:mm:ss").diff(moment(this.startTimes, "HH:mm:ss"))).format("mm")
     //  this.totalTimes = ([hrs,min].join(':'));
     //  this.addInvoicePopUpForm.controls['totaltime'].setValue( this.totalTimes);
   }

 }

 showStatusButton:boolean=false;
 touchTypeName:string="";

 DropDownActivityType(event){
  this.showStatusButton=true;
  var data=[];
  data =this.TouchesType.filter(x=>x.touchTypeID==event.value);
  if(data.length>0){
    this.touchTypeName=data[0].touchName;
  }
  this.getStatusList(event.value);
 }
  
}
